export function wait(delay = 0) {
	return new Promise<void>(() => {
		setTimeout(() => Promise.resolve(), delay);
	});
}

export function waitAsync<T>(delayInMs: number, resolveWith?: T): Promise<T> {
	return new Promise((resolve, reject) => {
		setTimeout(() => resolve(resolveWith), delayInMs);
	});
}

export async function waitCancellableAsync(delayInMs: number, cancellationToken: { cancel: () => void }) {
	return new Promise((resolve) => {
		const timeoutRef = setTimeout(resolve, delayInMs);
		cancellationToken.cancel = () => {
			// cancel timeout
			clearTimeout(timeoutRef);
			// The timeout is cancelled and won't trigger on its own
			// so we have to manually resolve the Promise.
			resolve(undefined);
		};
	});
}
